import React from 'react';
import { withRouter } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import ToolBar from '@material-ui/core/Toolbar';

import NavRoutes from './NavRoutes';

function AppNav () {
    return (
        <AppBar>
            <ToolBar>
                <NavRoutes />
            </ToolBar>
        </AppBar>
    );
}

export default withRouter(AppNav);
